import React from 'react';
import { useTranslation } from 'react-i18next';
import DocumentPackageCard from './DocumentPackageCard';
import { getPackageCoverSrc } from '../utils/partnerListUtils';
import { resolvePrivateJourneyPriceDisplay } from '../utils/privateJourneyPricing';

const MarketplacePackageCard = ({
  pkg,
  testId,
  onOpen,
  showOfferedBy = true,
  onOfferedByClick,
}) => {
  const { t } = useTranslation();
  const durationDays = pkg.duration_days || 0;
  const isPrivateJourney = Boolean(pkg.is_private_journey);
  const privatePrice = isPrivateJourney ? resolvePrivateJourneyPriceDisplay(pkg) : null;
  const handleOpen = () => {
    if (pkg.slug) onOpen?.(pkg);
  };

  const priceRow = isPrivateJourney
    ? {
      label: t('packagesPage.illustrativeGroupBudget'),
      value: privatePrice?.cardValue
        || pkg.illustrative_budget_label
        || t('packagesPage.onRequest'),
      extra: privatePrice?.cardExtra || t('packagesPage.groupTotalIllustrative'),
    }
    : {
      label: t('packagesPage.price'),
      value: `$${Number(pkg.base_price || 0).toLocaleString()}`,
      extra: t('packagesPage.perPerson'),
    };

  return (
    <DocumentPackageCard
      testId={testId || `agent-package-card-${pkg.id}`}
      imageUrl={getPackageCoverSrc(pkg)}
      imageAlt={pkg.title}
      containImage={false}
      photographerName={pkg.unsplash_photographer_name}
      photographerUsername={pkg.unsplash_photographer_username}
      badges={[
        isPrivateJourney ? t('packagesPage.privateBadge') : null,
        pkg.package_type,
      ].filter(Boolean)}
      offeredBy={showOfferedBy && pkg.partner_name ? {
        name: pkg.partner_name,
        logoUrl: pkg.partner_logo,
      } : null}
      onOfferedByClick={onOfferedByClick ? () => onOfferedByClick(pkg) : undefined}
      coverLabel={t('packagesPage.durationDays', { count: durationDays })}
      eyebrow={isPrivateJourney ? t('packagesPage.privateBadge') : pkg.package_type}
      title={pkg.title}
      location={pkg.destination}
      description={pkg.short_description}
      rows={[
        { label: t('packagesPage.destination'), value: pkg.destination },
        { label: t('packagesPage.duration'), value: t('packagesPage.daysCount', { count: durationDays }) },
        priceRow,
      ]}
      actionLabel={isPrivateJourney ? t('packagesPage.requestPrivate') : t('packagesPage.openPackage')}
      onClick={handleOpen}
      onAction={handleOpen}
    />
  );
};

export default React.memo(MarketplacePackageCard);
